import { Component } from "../lib/index.js";
import debounce from "../lib/debounce.js";

let store = new Map();

export default class ScrollManager extends Component {
	constructor(props) {
		super(props);

		this.handleScroll = this.handleScroll.bind(this);
		this.handleScrollTop = debounce(() => {
			if (this.props.target.current && this.props.target.current.scrollTop === 0) {
				this.props.onScrollTop();
			}
		}, 100);
		this.handleResize = this.handleResize.bind(this);

		this.stickToBottom = true;
		this.resizeObserver = new ResizeObserver(this.handleResize);
	}

	isAtBottom() {
		let target = this.props.target.current;
		return Math.abs(target.scrollHeight - target.clientHeight - target.scrollTop) <= 10;
	}

	saveScrollPosition(scrollKey) {
		let target = this.props.target.current;

		let sticky = target.querySelectorAll(this.props.stickTo);
		let stickToKey = null;
		if (!this.isAtBottom()) {
			for (let i = 0; i < sticky.length; i++) {
				let el = sticky[i];
				if (el.offsetTop >= target.scrollTop + target.offsetTop) {
					stickToKey = el.dataset.key;
					break;
				}
			}
		}

		store.set(scrollKey, stickToKey);
	}

	restoreScrollPosition() {
		let target = this.props.target.current;
		if (!target.firstChild) {
			return;
		}

		let stickToKey = store.get(this.props.scrollKey);
		if (!stickToKey) {
			target.firstChild.scrollIntoView({ block: "end" });
		} else {
			let stickTo = target.querySelector("[data-key=\"" + stickToKey + "\"]");
			if (stickTo) {
				stickTo.scrollIntoView();
			}
		}

		this.stickToBottom = !stickToKey;

		if (target.scrollTop === 0) {
			this.props.onScrollTop();
		}
	}

	handleScroll() {
		this.stickToBottom = this.isAtBottom();
		if (this.props.target.current.scrollTop === 0) {
			this.handleScrollTop();
		}
		if (this.props.onScroll) {
			this.props.onScroll();
		}
	}

	// Also watch the content, so images and link previews loading in keep the
	// view pinned to the bottom
	observeContent() {
		let content = this.props.target.current.firstChild;
		if (content === this.observedContent) {
			return;
		}
		if (this.observedContent) {
			this.resizeObserver.unobserve(this.observedContent);
		}
		if (content) {
			this.resizeObserver.observe(content);
		}
		this.observedContent = content;
	}

	handleResize() {
		if (this.stickToBottom && this.props.target.current.firstChild) {
			this.props.target.current.firstChild.scrollIntoView({ block: "end" });
		}
	}

	componentDidMount() {
		this.restoreScrollPosition();
		this.props.target.current.addEventListener("scroll", this.handleScroll);
		this.resizeObserver.observe(this.props.target.current);
		this.observeContent();
	}

	getSnapshotBeforeUpdate(prevProps) {
		if (this.props.scrollKey !== prevProps.scrollKey || this.props.children !== prevProps.children) {
			this.saveScrollPosition(prevProps.scrollKey);
		}
	}

	componentDidUpdate(prevProps) {
		if (!this.props.target.current) {
			return;
		}
		this.restoreScrollPosition();
		this.observeContent();
	}

	componentWillUnmount() {
		this.resizeObserver.disconnect();
		this.props.target.current.removeEventListener("scroll", this.handleScroll);
		this.saveScrollPosition(this.props.scrollKey);
	}

	render() {
		return this.props.children;
	}
}
